module.exports = __webpack_public_path__ + "40d77953ec7e60d6155f43966c6d5110.svg";